"use client";

import { ChevronLeft, OpenInNew, ShoppingCart, Visibility } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import Link from "next/link";
import { ReactNode } from "react";

const iconMap: Record<string, ReactNode> = {
    arrow: <ChevronLeft />,
    cart: <ShoppingCart />,
    eye: <Visibility />,
    external: <OpenInNew />,
};

interface CTALCSettings {
    label: string | null;
    variant: 'contained' | 'outlined' | 'text';
    color: string | null;
    text_color: string | null;
    size: 'small' | 'medium' | 'large';
    end_icon: string | null;
    full_width: boolean;
    border_radius: string | null;
    align: 'flex-start' | 'center' | 'flex-end' | null;
}

interface CTALCData {
    text: string;
    link: string | null;
}

export default function CTALC({ content }: {
    content: {
        settings: CTALCSettings;
        data: CTALCData;
    };
}) {
    const { settings, data } = content;
    if (!data?.text) return null;

    const variant = settings.variant ?? 'contained';
    const endIcon = settings.end_icon && settings.end_icon !== 'none' ? iconMap[settings.end_icon] : undefined;

    return (
        <Box sx={{ display: 'flex', justifyContent: settings.align || 'flex-start' }}>
            <Button
                component={data.link ? Link : 'button'}
                href={data.link ?? undefined}
                variant={variant}
                size={settings.size ?? 'medium'}
                fullWidth={settings.full_width}
                endIcon={endIcon}
                disableElevation
                sx={{
                    textDecoration: 'none',
                    ...(settings.border_radius && { borderRadius: `${settings.border_radius}px` }),
                    ...(settings.color && variant === 'contained' && {
                        bgcolor: settings.color,
                        '&:hover': { bgcolor: settings.color, filter: 'brightness(0.9)' },
                    }),
                    ...(settings.color && variant === 'outlined' && {
                        borderColor: settings.color,
                        '&:hover': { borderColor: settings.color },
                    }),
                    ...(settings.text_color && { color: `${settings.text_color} !important` }),
                }}
            >
                {data.text}
            </Button>
        </Box>
    );
}
